module.exports = __webpack_public_path__ + "static/media/footerTel.e72c3284.svg";